function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_196",
  "data-name": "Path 196",
  d: "M11.961,0A11.961,11.961,0,1,0,23.922,11.961,11.974,11.974,0,0,0,11.961,0Zm0,0",
  fill: "#ffc107"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_197",
  "data-name": "Path 197",
  d: "M236.661,363.665a1,1,0,1,1-1-1A1,1,0,0,1,236.661,363.665Zm0,0",
  transform: "translate(-223.704 -345.723)",
  fill: "#eceff1"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_198",
  "data-name": "Path 198",
  d: "M166.064,93.946a1,1,0,0,0-.581.906V95.3a1,1,0,1,1-1.993,0v-.448a3,3,0,0,1,1.739-2.717,3.258,3.258,0,0,0,1.749-2.318,2.492,2.492,0,0,0-4.984,0,1,1,0,1,1-1.994,0,4.485,4.485,0,1,1,8.971,0,5.194,5.194,0,0,1-2.908,4.129Zm0,0",
  transform: "translate(-152.525 -81.345)",
  fill: "#fafafa"
});

function SvgSkippedFill2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "question",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.922,
    height: 23.922,
    viewBox: "0 0 23.922 23.922",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkippedFill2);
export default __webpack_public_path__ + "static/media/skipped_fill_2.fca72eea.svg";
export { ForwardRef as ReactComponent };